import { Injectable } from '@angular/core';
import { createFrom, EventService, ProductSearchPage, ProductSearchService } from '@spartacus/core';
import { map, skip, switchMap } from 'rxjs/operators';
import { NavigationEvent } from '@spartacus/storefront';
import { EMPTY } from 'rxjs';
import { GtmGgCategoryPageEvent } from './gtm-gg-category-page-event';

@Injectable({
  providedIn: 'root',
})
export class GtmGgCategoryPageEventBuilder {
  constructor(
    private eventService: EventService,
    private productSearchService: ProductSearchService
  ) {
    const searchResults$ = this.productSearchService.getResults().pipe(skip(1));

    const eventSource = this.eventService.get(NavigationEvent).pipe(
      switchMap((navigationEvent: NavigationEvent) => {
        if (navigationEvent?.semanticRoute !== 'category') {
          return EMPTY;
        }

        return searchResults$.pipe(
          map((searchResults) =>
            createFrom(GtmGgCategoryPageEvent, {
              event: 'product-impressions',
              list: this.getLastBreadcrumbFromProductSearchPage(searchResults)
                ? this.getLastBreadcrumbFromProductSearchPage(searchResults).facetValueName
                : '',
              ecommerce: {
                impressions: this.getImpressionsFromProductSearchPage(searchResults),
              },
            })
          )
        );
      })
    );

    eventService.register(GtmGgCategoryPageEvent, eventSource);
  }

  getLastBreadcrumbFromProductSearchPage(productSearchPage: ProductSearchPage) {
    let lastBreadcrumb;

    if (productSearchPage.breadcrumbs) {
      productSearchPage.breadcrumbs?.forEach((breadcrumb) => {
        lastBreadcrumb = breadcrumb;
      });
    }

    return lastBreadcrumb;
  }

  getImpressionsFromProductSearchPage(productSearchPage: ProductSearchPage) {
    const impressions: {
      name?: string;
      price?: string;
      category?: string;
      list?: string;
      position?: string;
      id?: string;
      brand?: string;
    }[] = [];

    productSearchPage.products?.forEach((product, index) => {
      const impression = {
        name: product.name ? product.name : '',
        price: product.price?.value ? product.price.value.toString() : '',
        list: this.getLastBreadcrumbFromProductSearchPage(productSearchPage)
          ? this.getLastBreadcrumbFromProductSearchPage(productSearchPage).facetValueName
          : '',
        position: (index + 1).toString(),
        id: product.code ? product.code : '',
        brand: product.manufacturer ? product.manufacturer : '',
      };

      impressions.push(impression);
    });

    return impressions;
  }
}
